import { takeEvery, select } from 'redux-saga/effects'
import { webStorage, validateProfilingConsent } from 'utils'

import {
  property as propertyActions,
} from 'flux/actions'

import {
  property as propertySelectors,
} from 'flux/selectors'

export function* onSetProfilingConsent({ payload: { profilingConsent } }) {
  const { id: propertyId } = yield select(propertySelectors.selectProperty)

  const profilingConsentKey = 'profilingConsent'
  let profilingConsentMapping = {}
  try {
    profilingConsentMapping = JSON.parse(webStorage.getItem(profilingConsentKey))
    profilingConsentMapping = typeof profilingConsentMapping === 'object' && profilingConsentMapping !== null ? profilingConsentMapping : {}
    profilingConsentMapping[propertyId] = validateProfilingConsent(profilingConsent)
  } catch (e) {
    // If the value stored at the webStorageKey is not a JSON format, delete it
    webStorage.removeItem(profilingConsentKey)
    profilingConsentMapping[propertyId] = validateProfilingConsent(profilingConsent)
  }

  webStorage.setItem(profilingConsentKey, JSON.stringify(profilingConsentMapping))
}

export default function* () {
  yield takeEvery(propertyActions.types.SET_PROFILING_CONSENT, onSetProfilingConsent)
}
